import { render, staticRenderFns } from "./custome-loading.vue?vue&type=template&id=161d4c48&scoped=true&"
import script from "./custome-loading.vue?vue&type=script&lang=js&"
export * from "./custome-loading.vue?vue&type=script&lang=js&"
import style0 from "./custome-loading.vue?vue&type=style&index=0&id=161d4c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d4c48",
  null
  
)

export default component.exports